var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Page Not Found'
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "140"
    }
  }, [_vm._v(" Home ")])], 1)], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": "assets/images/404.jpg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "mt-4 text-center"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("The page you're looking for does not exist")]), _c('b-button', {
    staticClass: "outline-theme-btn",
    attrs: {
      "pill": "",
      "variant": "outline-light"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("Back to Homepage")])], 1)])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }